
        var result = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./context-item.component.styl");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/lib/context/context-item/context-item.component.styl
// module id = 966
// module chunks = 0